// removed by extract-text-webpack-plugin
module.exports = {"percentagePositive":"src-components-Percentage-___index__percentagePositive___3Z2hF","percentageNegative":"src-components-Percentage-___index__percentageNegative___yIPHg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Percentage/index.css
// module id = 1054
// module chunks = 3